<template>
  <div class="">
    <div class="content_box">
      <h2>1、友邻少年的“{{ integralName }}”是什么？</h2>
      <p class="p_box">
        “{{ integralName }}”是友邻APP的积分系统， 友邻学员完成任务，即可获得相应的{{ integralName }}。
      </p>
      <h2>2、“{{ integralName }}”有什么用途？</h2>
      <p class="p_box">在您的友邻少年APP账户内，已到账的“{{ integralName }}”，可在积分商城内免费兑换相应实体物品。</p>
    </div>
  </div>
</template>

<script>
import { integralName } from '@/pages/config'
export default {
  data() {
    return {
      title: '活动规则',
      dheight: 0,
      integralName
    }
  },
  methods: {}
}
</script>

<style lang="less" scoped>
.content_box {
  h2 {
    font-size: 0.3rem;
    padding: 0.4rem 0 0.2rem;
  }
  .p_box {
    font-size: 0.28rem;
    line-height: 0.4rem;
    color: #666666;
    span {
      color: #d93a3a;
    }
  }
  .table_box {
    font-size: 0.28rem;
    flex-direction: column;
    margin: 0.4rem 0;
    border-top: 1px solid #666666;
    border-left: 1px solid #666666;
    align-items: stretch;
    .table_header {
      width: 100%;
      background-color: #e1e1e1;
    }
  }
}
</style>
